export default "__VITE_ASSET__CCVps0Et__"